export const Language = {
  English: 'English',
  Norwegian: 'Norwegian',
  German: 'German',
};

Object.freeze(Language);
